import styled from "styled-components";
import * as zero from '@zero/design-tokens/build/js/variables'


type BadgeContainerProps = {
    textColor: 'black' | 'white',
    backgroundColor: string    
}

export const BadgeContainer = styled.div<BadgeContainerProps>`   
    height: 18px;
    width: fit-content;

    padding: 2px 8px;
    
    border-radius: 4px;
    border: 1px solid white;
    
    display: flex;
    align-items: center;
    
    background-color: ${(props) => props.backgroundColor};
    
    span {
        font-family: ${zero.ZrFontFamilyDigitalRegular};
        font-size: 10px;
        color: ${(props) => props.textColor};
    }
`